import { useEffect, useState } from 'react'
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Coins, CreditCard, Home, Link2, Sparkles } from 'lucide-react'
import { whoami, type WhoAmI } from './lib/api'
import { Dashboard } from './components/Dashboard'
import { Cards } from './components/Cards'
import { Connections } from './components/Connections'
import { LoggedOut } from './components/LoggedOut'
import { Recommend } from './components/Recommend'
import { Programs } from './components/Programs'

const NAV = [
  { to: '/', label: 'home', icon: Home },
  { to: '/cards', label: 'cards', icon: CreditCard },
  { to: '/programs', label: 'programs', icon: Coins },
  { to: '/recommend', label: 'recommend', icon: Sparkles },
  { to: '/connections', label: 'connections', icon: Link2 },
]

export default function App() {
  const [auth, setAuth] = useState<WhoAmI | null>(null)
  const location = useLocation()

  useEffect(() => {
    whoami().then(setAuth).catch(() => setAuth({ authenticated: false }))
  }, [])

  if (auth === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
        loading…
      </div>
    )
  }

  if (!auth.authenticated) {
    return <LoggedOut />
  }

  return (
    <div className="min-h-screen flex">
      <aside className="w-56 border-r border-zinc-900 px-4 py-6 flex flex-col gap-1">
        <div className="px-3 mb-6 text-zinc-400">
          <div className="text-xs uppercase tracking-widest">money</div>
          <div className="text-[11px] text-zinc-600 truncate" title={auth.email}>
            {auth.email}
          </div>
        </div>
        {NAV.map(({ to, label, icon: Icon }) => {
          const active = to === '/' ? location.pathname === '/' : location.pathname.startsWith(to)
          return (
            <Link
              key={to}
              to={to}
              className={
                'flex items-center gap-3 px-3 py-2 rounded text-sm transition-colors ' +
                (active
                  ? 'bg-zinc-900 text-zinc-100'
                  : 'text-zinc-500 hover:bg-zinc-900/50 hover:text-zinc-200')
              }
            >
              <Icon size={15} strokeWidth={1.5} />
              {label}
            </Link>
          )
        })}
        <div className="mt-auto px-3 pt-6 text-[10px] text-zinc-700">
          identity-service · cookie · {auth.method}
        </div>
      </aside>
      <main className="flex-1 px-10 py-8 max-w-5xl">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/recommend" element={<Recommend />} />
          <Route path="/connections" element={<Connections />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}
